"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var vue_1 = __importDefault(require("vue"));
require("ngVue");
var EditCourse_vue_1 = __importDefault(require("./EditCourse.vue"));
var edit_course_controller_1 = __importDefault(require("./edit-course.controller"));
var admin_edit_course_html_1 = __importDefault(require("./admin-edit-course.html"));
var time_1 = require("../../../common/helpers/time");
function getCourse($stateParams, CoursesModel) {
    return CoursesModel.show($stateParams.courseId).then(function (response) {
        response.course.date = (0, time_1.dateStringToDate)(response.course.date);
        response.course.time = (0, time_1.timeStringToDate)(response.course.time);
        var durationParts = (0, time_1.toHoursAndMinutes)(response.course.duration).split(":");
        response.course.duration = {
            hours: durationParts[0],
            minutes: durationParts[1],
        };
        return response.course;
    });
}
getCourse.$inject = ["$stateParams", "CoursesModel"];
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes.filter(function (type) { return type.status === "Active"; });
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.courses.edit", {
        url: "/edit/:courseId",
        template: admin_edit_course_html_1.default,
        controller: edit_course_controller_1.default,
        controllerAs: "vm",
        resolve: {
            course: getCourse,
            courseTypes: getCourseTypes,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.courses.edit", [])
    .config(config)
    .controller("AdminCoursesEditController", edit_course_controller_1.default)
    .directive("dcEditCourse", [
    "createVueComponent",
    function (createVueComponent) {
        return createVueComponent(vue_1.default.component("DcEditCourse", EditCourse_vue_1.default));
    },
]);
